import React from "react";
import CommonWithoutSubscription from "@/pages/att/components/commonNosubscription";
import {useTranslation} from "react-i18next";


const OvertimeWithoutSubscription: React.FC = () => {
  const {t} = useTranslation();

  return (
    <>
      <CommonWithoutSubscription label={t("common.Overtime Analysis Report")}
                                 tips1={t("common.Unlock Overtime Analysis Report")}
                                 tips2={t("common.Get advanced data analysis and exclusive reports.")}
                                 tips3={t("Dashboard.Access all features immediately after subscribing.")}/>
    </>
  )
};

export default OvertimeWithoutSubscription;
